// Footer.js
import React from "react";
import USClogo from "../images/logo-USC.png";
import NEHlogo from "../images/logo-NEH.png";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* <div className="footer-section">
          <h3>Contact</h3>
          <br></br>
          <p>Email: charm@usc.edu</p>
        </div> */}
        <div className="footer-section">
          <h3>Funding</h3>
          <br></br>
          <p>USC Ahmanson Lab Collaboratory (2019-20)</p>
          <p>
            USC Office of Research: Zumberge Collaboration Grants (2019, 2020)
          </p>
          <p>
            NEH Digital Humanities Advancement Phase II Grant (Jan 2020-Dec
            2023)
          </p>
        </div>
        <div className="footer-section">
          {/* Place your icon here */}
          <img src={NEHlogo} style={{ width: 200 }} alt="Icon" />
          <br></br>
          <img src={USClogo} style={{ width: 300 }} alt="Icon" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
